"use strict";

exports.__esModule = true;
exports.TimestampSelector = TimestampSelector;
var _react = _interopRequireDefault(require("react"));
var _TimestampRangeSelector = require("./TimestampRangeSelector");
var _TimestampSelectorPopover = require("./TimestampSelectorPopover");
var _excluded = ["multiple"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Allows a user to select a timestamp from a calendar.
 */
function TimestampSelector(_ref) {
  var multiple = _ref.multiple,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (multiple) {
    return /*#__PURE__*/_react["default"].createElement(_TimestampRangeSelector.TimestampRangeSelector, props);
  }
  return /*#__PURE__*/_react["default"].createElement(_TimestampSelectorPopover.TimestampSelectorPopover, props);
}